export default __webpack_public_path__ + "static/DSC_0095-e1b069844df998503aeea122b57092b9.jpg";